// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { tenet as _tenet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the tenet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1559
 * Chain Name: Tenet
 * Default Block Explorer: https://tenetscan.io
 * Default RPC URL: https://rpc.tenet.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { tenet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: tenet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const tenet = createCommon({
	..._tenet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
